// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TsDu","fullView":"styles_fullView__3AF00"};